import type { FixedIconProps } from "../../../../../../mads/icons/Icon";
import type { ComponentType } from "react";
import type { ColorValue } from "react-native";

import { Box, Flex, Text } from "../../../../../../mads";

import { colors, fontSizes, spacing } from "@indeed/ifl-tokens/react-native";

type EmployerInsightListItemProps = {
  icon: ComponentType<FixedIconProps>;
  iconColor?: ColorValue;
  headingText: string;
  description?: string;
};

export function EmployerInsightListItem(props: EmployerInsightListItemProps) {
  return (
    <Flex sx={{ flexDirection: "row", gap: spacing.s2 }}>
      <props.icon aria-hidden size="sm" color={props.iconColor} />
      <Box sx={{ flex: 1 }}>
        <Text level={2} variant="contrast" sx={{ fontWeight: "bold" }}>
          {props.headingText}
        </Text>
        {!!props.description && (
          <Text sx={{ fontSize: fontSizes.f1, color: colors.neutral700 }}>{props.description}</Text>
        )}
      </Box>
    </Flex>
  );
}
